import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'info-pills',
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
});
